import { render, staticRenderFns } from "./normsMaintainNew.vue?vue&type=template&id=fe8e88e0&scoped=true"
import script from "./normsMaintainNew.vue?vue&type=script&lang=js"
export * from "./normsMaintainNew.vue?vue&type=script&lang=js"
import style0 from "./normsMaintainNew.vue?vue&type=style&index=0&id=fe8e88e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8e88e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe8e88e0')) {
      api.createRecord('fe8e88e0', component.options)
    } else {
      api.reload('fe8e88e0', component.options)
    }
    module.hot.accept("./normsMaintainNew.vue?vue&type=template&id=fe8e88e0&scoped=true", function () {
      api.rerender('fe8e88e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/organizationChild/child/normsMaintainNew.vue"
export default component.exports